<div class="row">

  <div class="col">
    <app-product-list></app-product-list>
  </div>

  <div *ngIf="isLogged && !isMerchant" class="col-sm-2">
    <app-cart></app-cart>
  </div>
</div>